import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';

import BaseTrigger from './BaseTrigger';

import { trackAction } from 'util/analytics';

const baseString = 'vra-rename-trigger';
const RenameTrigger = ({
  className,
  scriptId,
  onClickRenameTrigger,
  disabled
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  return (
    <BaseTrigger
      className={classString}
      content={getMessage('button-text__rename')}
      dataTestId={baseString}
      disabled={disabled}
      handler={() => { 
        trackAction(`Clicked on Rename, Rx: ${scriptId}`);
        onClickRenameTrigger(scriptId);
      }}
    />
  );
};
RenameTrigger.propTypes = {
  className: propTypes.string,
  onClickRenameTrigger: propTypes.func.isRequired,
  scriptId: propTypes.string.isRequired,
  disabled: propTypes.bool
};
export default RenameTrigger;
